import { Sentry } from './sentry';
import { init, withScope, captureException } from '@sentry/react';
const sdk = { init, withScope, captureException };
export const sentryReact = new Sentry(sdk);
